<template>
  <span class="bib-display">
    <span :style="bibStyle">{{ bibNumberDisp }}</span>
  </span>
</template>

<style lang="scss">
  .bib-display {
    --perspective: 100px;
    --tip: 0deg;
    --rotate: 0deg;
    --top: 0px;
    --background: var(--light-bgcolor);
    margin-left: 0.25em;
    margin-right: 1em;
    
    span {
      background: var(--background) !important;
      display: inline-block;
      color: var(--light-color);
      border-radius: 4px;
      line-height: 1em;
      padding: 4px 8px !important;
      min-width: 3ex;
      text-align:center;
      font-weight: bold;
      box-shadow: 0 0px 15px rgba(0,0,0,0.5);
      transform: translateY(var(--top)) perspective(var(--perspective)) rotate3d(1, 0, 0, var(--tip)) rotate(var(--rotate));
      height: 1.2em;
      line-height: 1.2em;
    }
  }
</style>

<script>
  export default  {
    props: {
      bibNumber: {
        required: false,
        default() { return undefined }
      },
      
      perspective: {
        required: false,
        default() {return undefined}
      },

      top: {
        required: false,
        default() {return undefined}
      },

      tip: {
        required: false,
        default() {return undefined}
      },

      rotate: {
        required: false,
        default() {return undefined}
      },
      
      color: {
        type: String,
        default() { return '#ff0000'}
      }
    },
    
    computed: {
      bibNumberDisp() {
        if (this.bibNumber) return this.bibNumber;
        return '—'
      },
      
      bibStyle() {
        let c = `border-top: 8px solid ${this.color}; padding-top: 0px;`;
        if (undefined !== this.perspective) c += `--perspective: ${this.perspective}px;`;
        if (undefined !== this.tip) c += `--tip: ${this.tip}deg;`;
        if (undefined !== this.rotate) c += `--rotate: ${this.rotate}deg;`;
        if (undefined !== this.top) c += `--top: ${this.top}px;`;

        return c;
      }
    }
  }
</script>